import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CapacitorHttpService } from '@monorepo/services';
import { ANServiceEndPoints, AnEnvProvider } from '../../services/analytic-env-provider';

type TdefectsInfo = {
  operations_issues: { operation: string; issues: string[] }[];
  image_urls: string[];
};

type TResponseDefectsList = {
  sessionDate: string;
  module_id: string;
  buyer: string;
  style: string;
  po: string;
  color: string;
  erp_key: string;
  product_type: string;
  product_category: string;
  defective_info: TdefectsInfo[];
};

@Component({
  selector: 'monorepo-defects-list',
  templateUrl: './defects-list.component.html',
  styleUrls: ['./defects-list.component.scss'],
})
export class DefectsListComponent {
  defectList: TResponseDefectsList = {
    sessionDate: '',
    module_id: '',
    buyer: '',
    style: '',
    po: '',
    color: '',
    erp_key: '',
    product_category: '',
    product_type: '',
    defective_info: [],
  };
  constructor(
    private route: ActivatedRoute,
    private capacitorHttpService: CapacitorHttpService,
    private envProvider: AnEnvProvider,
  ) {}

  ionViewWillEnter() {
    const finderParam = this.route.snapshot.queryParamMap['params']['finder'] || '';
    console.log('finderAPI', finderParam);
    this.getDefectList(finderParam).then((res) => {
      console.log('defectList', res);
      this.defectList = res.data;
    });
  }

  getDefectList(finderParam: string) {
    const url = this.envProvider.getEnvVar(ANServiceEndPoints.DEFECTS_LIST);
    return this.capacitorHttpService.get<TResponseDefectsList>(url, { finder: finderParam });
  }
}
